"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = assert;
exports.assertNever = assertNever;
const assertError_1 = require("./assertError");
function assert(value, messageOrCallback) {
    if (!value) {
        const message = typeof messageOrCallback === 'function'
            ? messageOrCallback()
            : messageOrCallback;
        throw new assertError_1.AssertError(value, message);
    }
}
function assertNever(value) {
    throw new Error('Unexpected object: ' + JSON.stringify(value));
}
//# sourceMappingURL=assertHelper.js.map